import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { Suspense } from "react";
import { Helmet } from "react-helmet";
import routes from "./routes";
import Loader from "./components/Loader/Loader";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/footer";
import { PageTransition } from "./ui";
import { useSelector } from "react-redux";
import { selectSignLanguage } from "./features/settings/settingsSlice";

function AnimatedRoutes() {
  const location = useLocation();
  const language = useSelector(selectSignLanguage);
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={`${location.pathname}|${language.id}`}>
        {routes.map((route, i) => (
          <Route key={i} path={route.path} element={<PageTransition>{route.element}</PageTransition>} />
        ))}
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <Helmet>
        <title>Signi</title>
        <meta name="description" content="Learn sign language with your camera: short lessons and games that check every sign." />
        <meta name="keywords" content="sign, language, asl, game" />
      </Helmet>
      <NavBar />
      <ReactNotifications />
      <Suspense fallback={<Loader />}>
        <main>
          <AnimatedRoutes />
        </main>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
